class TrapScreenReader {
    root;
    /**
     * Elements ignored by screen reader when trap is active
     */
    hiddenElements = [];
    constructor(root) {
        this.root = root;
    }
    /**
     * Apply aria-hidden to all elements except the passed
     */
    hideSiblingsFromScreenReader = (el) => {
        let sibling = el.parentNode && el.parentNode.firstChild;
        while (sibling) {
            const notCurrent = sibling !== el;
            const isValid = sibling.nodeType === 1 && !sibling.hasAttribute("aria-hidden");
            if (notCurrent && isValid) {
                sibling.setAttribute("aria-hidden", "true");
                this.hiddenElements.push(sibling);
            }
            sibling = sibling.nextSibling;
        }
    };
    release = () => {
        this.hiddenElements.forEach((el) => {
            el.removeAttribute("aria-hidden");
        });
        this.hiddenElements = [];
    };
    trap = () => {
        let currentEl = this.root;
        this.release();
        // Stop at the body level for regular pages
        // And stop at shadow root
        while (currentEl !== document.body && currentEl.parentElement) {
            this.hideSiblingsFromScreenReader(currentEl);
            currentEl = currentEl.parentElement;
        }
    };
}
export default TrapScreenReader;
